<template>
    <b-card class="mb-3">
        <div class="mx-0 mb-4 row">
            <h5 class="">
                {{ $t('menu.createDealer') }}
            </h5>
            <div class="ml-auto">
                <button type="button" class="close" @click="closeForm" :title="$t('general.cancel')">
                    <close-icon title="" />
                </button>
            </div>
        </div>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-form @submit.prevent="create">
            <b-form-group :label="$t('general.iin')" label-cols-sm="3">
                <the-mask v-model="formData.iin" mask="############" class="form-control" required />
            </b-form-group>
            <b-form-group :label="$t('dealer.name')" label-cols-sm="3">
                <b-form-input v-model="formData.name"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('dealer.industry')" label-cols-sm="3">
                <b-form-input v-model="formData.industry"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('dealer.phone')" label-cols-sm="3">
                <the-mask v-model="formData.phoneNumber" mask="+7 (7##) ###-##-##"
                    placeholder="+7 (7__) ___-__-__" :masked="true" class="form-control" required/>
            </b-form-group>
            <b-form-group :label="$t('dealer.addressCity')" label-cols-sm="3">
                <multiselect v-model="selectedCity" :options="cities" :close-on-select="true" :hide-selected="true" :show-no-results="false"
                            @search-change="findCity" :internal-search="false"
                            label="name" :placeholder="$t('general.enterValue')" :select-label="''">
                    <template slot="noOptions">
                        <span>
                            {{ $t('general.enterValue' )}}
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <b-form-group v-show="selectedCity" :label="$t('dealer.addressStreet')" label-cols-sm="3">
                <multiselect v-model="selectedStreet" :options="streets" @input="addressSelected"
                            :close-on-select="true" :hide-selected="true" :showNoResults="false"
                            @search-change="findAddress" :internal-search="false"
                            label="name" :placeholder="$t('general.enterValue')" :select-label="''">
                    <template slot="noOptions">
                        <span>
                            {{ $t('general.enterValue' )}}
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <b-form-group v-show="selectedStreet" :label="$t('dealer.addressHouse')" label-cols-sm="3">
                <vue-bootstrap-typeahead v-model="formData.addressHome" :data="houses" :serializer="h => h.name"
                    :min-matching-chars="1" />
            </b-form-group>
            <b-form-group :label="$t('dealer.ndsPayer')" label-cols-sm="3">
                <b-form-checkbox v-model="formData.isNdsPayer"></b-form-checkbox>
            </b-form-group>
            <b-form-group v-if="formData.isNdsPayer" :label="$t('dealer.ndsCertificateSeries')" label-cols-sm="3">
                <b-form-input v-model="formData.ndsCertificateSeries" required></b-form-input>
            </b-form-group>
            <b-form-group v-if="formData.isNdsPayer" :label="$t('dealer.ndsCertificateNum')" label-cols-sm="3">
                <b-form-input v-model="formData.ndsCertificateNumber" required></b-form-input>
            </b-form-group>
            <b-form-row class="justify-content-end mx-0">
                <b-button type="button" variant="danger" @click="closeForm" :disabled="isDisabled" class="mr-2">
                    <close-icon title="" />&nbsp;{{ $t('general.cancel') }}
                </b-button>
                <b-button type="submit" variant="success" :disabled="isDisabled">
                    <plus-icon title="" />&nbsp;{{ $t('general.create') }}
                </b-button>
            </b-form-row>
        </b-form>
    </b-card>
</template>

<script>
/* eslint-disable */
import { executeAfterTwoSeconds } from '@/utils/utils';

export default {
    name: 'CreateDealer',
    props: {
        onCreated: Function,
        closeForm: Function
    },
    data () {
        return {
            showAlert: false,
            alert: '',
            formData: {
                iin: '',
                name: '',
                industry: '',
                addressId: null,
                addressHome: null,
                phoneNumber: null,
                isNdsPayer: false,
                ndsCertificateSeries: '',
                ndsCertificateNumber: ''
            },
            selectedCity: null,
            selectedStreet: null,
            cities: [],
            streets: [],
            houses: []
        }
    },
    computed: {
        isDisabled: function () {
            return this.$store.getters.isLoading
        }
    },
    methods: {
        findCity: executeAfterTwoSeconds(function(query) {
            if (query.length < 3)
                return;

            const request = {
                data: { address: query },
                onSuccess: cities => this.cities = cities,
                onError: this.displayAlert 
            };

            this.$request.getCities(this, request);
        }),
        findAddress: executeAfterTwoSeconds(function (query) {
            if (query.length < 3)
                return;

            const request = {
                data: { 
                    address: query,
                    parentId: this.selectedCity.pointId 
                },
                onSuccess: streets => this.streets = streets,
                onError: this.displayAlert 
            };

            this.$request.getStreets(this, request);
        }),
        addressSelected: executeAfterTwoSeconds(function (house) {
            this.formData.addressId = house != null 
                ? house.id 
                : null;
            
            const request = {
                data: { parentId: this.formData.addressId },
                onSuccess: houses => this.houses = houses,
                onError: this.displayAlert 
            };

            this.$request.getHouses(this, request);
        }),
        create() {
            this.hideAlert()
            if (this.formData.addressId == null || this.formData.addressHome == null || this.formData.addressHome.trim() === '') {
                this.displayAlert('addressMustBeSet');
                return;
            }

            if (this.formData.phoneNumber != null)
                this.formData.phoneNumber = this.formData.phoneNumber.replace(/\D/g, '');

            const onSuccess = response => {
                this.onCreated({ id: response });
                this.closeForm();
            };

            this.$request.sendRequest(
                this, 
                this.$appConfig.apiUrls.dealer.create,
                this.formData,
                onSuccess,
                this.displayAlert);
        },
        hideAlert() {
            this.showAlert = false
            this.alert = ''
        },
        displayAlert(errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`)
            this.showAlert = true
        }
    }
}
</script>
